/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

export enum LoginTypes {
   "Waiting" = "Waiting",
   "SecurIDPasscode" = "SecurIDPasscode",
   "WindowsPassword" = "WindowsPassword",
   "Disclaimer" = "Disclaimer",
   "Unauthenticated" = "Unauthenticated",
   "WindowsPasswordExpired" = "WindowsPasswordExpired",
   "SecurIDNextTokenCode" = "SecurIDNextTokenCode",
   "SecurIDPinChange" = "SecurIDPinChange",
   "SecurIDWait" = "SecurIDWait",
   "SAML" = "SAML",
   "UNKNOWN" = "UNKNOWN"
}

export type LoginTypesKey = keyof typeof LoginTypes;

// move definition from component here in later patch
export type LoginContentData = any;

export type LoginData = {
   name: LoginTypesKey;
   content?: LoginContentData;
};
